import * as React from "react";
import { mapStatusToStyle } from "./dashboardUtils";
import { niceNumber } from "@/lib/util";
import type {
    DashboardData,
    DashboardResultIndicatorObj,
    DashboardResultIndicatorObjLine,
    DashboardResultIndicatorObjTs,
    DashboardLayout,
} from "@/lib/models";

type Props = {
    label: string;
    value: number;
    unit?: string;
    indicator_type?: string;
    indicator_style: string;
    dec_places?: number;
    value_display_type?: string;
    onClick: () => void;
};

class IndicatorValue extends React.Component<Props> {
    render() {
        const style = "dsh_indicator_container " + this.props.indicator_style;
        let value = this.props.value;
        let unit = this.props.unit || "";
        if (this.props.value_display_type === "percent") {
            value *= 100;
            unit = "% " + unit;
        }

        let val = "" + value;
        if (this.props.dec_places !== undefined) {
            val = niceNumber(value, this.props.dec_places);
        }

        if (this.props.indicator_type === "compact") {
            return (
                <div className={style} onClick={() => this.props.onClick()}>
                    <div className="dsh_indicator_content">
                        <h1>{this.props.label}</h1>
                        <h2>
                            {val}
                            {unit}
                        </h2>
                    </div>
                </div>
            );
        }
        if (this.props.indicator_type === "tiny") {
            return (
                <div className={style} onClick={() => this.props.onClick()}>
                    <div className="dsh_indicator_content">
                        <h3>{this.props.label}</h3>
                        <h5>
                            {val}
                            {unit}
                        </h5>
                    </div>
                </div>
            );
        }

        return (
            <div className={style} onClick={() => this.props.onClick()}>
                <div className="dsh_indicator_content">
                    {this.props.label}: {val}
                    {unit}
                </div>
            </div>
        );
    }
}

export function createIndicator(data: DashboardData, widget: DashboardLayout) {
    const hits = data.indicators.filter(x => x.key === widget.key) as DashboardResultIndicatorObj[];
    if (hits.length === 0) {
        return (
            <div className={"dsh_indicator_container " + mapStatusToStyle("error")}>
                {" "}
                Indicator not found {widget.key}{" "}
            </div>
        );
    }
    const hit = hits[0];
    hit.type = hit.type || "ts";
    const url = widget.url;
    if (hit.type === "ts" || hit.type === "aggr" || hit.type === "man_stock_aggr") {
        const tsHit = hit as DashboardResultIndicatorObjTs;
        const indicator_type = widget.indicator_type || "normal";
        const value_display_type = widget.value_display_type || "normal";
        const dec_places = widget.dec_places;
        const value = +tsHit.val;
        const indicator_style = mapStatusToStyle(tsHit.status);
        return (
            <IndicatorValue
                label={widget.label || ""}
                value={value}
                indicator_type={indicator_type}
                indicator_style={indicator_style}
                unit={widget.unit}
                dec_places={dec_places}
                value_display_type={value_display_type}
                onClick={() => {
                    if (url) {
                        window.location.href = url;
                    }
                }}
            />
        );
    } else if (hit.type === "line") {
        const lineHit = hit as DashboardResultIndicatorObjLine;
        const gui_status = lineHit.status === "on" ? "ok" : lineHit.status === "downtime" ? "error" : "inactive";
        const style = "dsh_indicator_container dsh_indicator_container_glued " + mapStatusToStyle(gui_status);
        const status_workorder =
            "dsh_indicator_bullet " + mapStatusToStyle(lineHit.workorder_is_late ? "error" : "ok", "dsh_bullet_style_");
        let parts_text = niceNumber(lineHit.parts_produced, 0) + " / " + niceNumber(lineHit.parts_total, 0);
        const style_outter = url ? "dsh_indicator_pointer" : "";
        return (
            <div
                className={style_outter}
                onClick={() => {
                    if (url) {
                        window.location.href = url;
                    }
                }}
            >
                <div className={style}>
                    <div className="dsh_indicator_content">
                        <h2>{lineHit.title}</h2>
                        <h3>{lineHit.product}</h3>
                        <h3>{lineHit.person}</h3>
                    </div>
                </div>
                <div className="dsh_indicator_body white_box white_box_glued charts">
                    <p>
                        {" "}
                        <span className={status_workorder}></span> Parts: {parts_text}{" "}
                    </p>
                </div>
            </div>
        );
    } else {
        return (
            <div className={"dsh_indicator_container " + mapStatusToStyle("error")}>
                <div className="dsh_indicator_content">
                    <h4>
                        mismatch - indicators other than simple timeseries (type 'ts') and manufacturing line (type
                        'line') are not supported on classic dashboard type - {hit.type}
                    </h4>
                </div>
            </div>
        );
    }
}
